import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { WebhookEditForm } from "@/components/webhooks/webhook-edit-form"
import { FRONTEND_ROUTES } from "@/constants"

export function WebhookEditPage() {
  const { t } = useTranslation()
  const { webhookId } = useParams<{ webhookId: string }>()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.WEBHOOKS.href,
              label: t("sidebar.webhooks"),
            },
            {
              label: t("common.edit"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <WebhookEditForm webhookId={webhookId || ""} />
      </section>
    </DashboardContainer>
  )
}
